import {
  SHOW_CARDS_FAILED,
  SHOW_CARDS_INVALID_REQUEST,
  SHOW_CARDS_NOT_FOUND,
  SHOW_CARDS_SUCCESS,
  LOADING_SHOW_CARDS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SHOW_CARDS:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        data: {},
      };
    case SHOW_CARDS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        data: action.payload,
      };

    case SHOW_CARDS_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
      };
    case SHOW_CARDS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        data: action.payload,
      };
    case SHOW_CARDS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        data: action.payload,
      };

    default:
      return state;
  }
};
